import React from 'react';
import { BookingSlot, BrandRequest } from '../../data/types';
interface TimelineSlotProps {
  slot: BookingSlot;
  isAdmin: boolean;
  brandRequests: BrandRequest[];
  onClick: () => void;
}
export function TimelineSlot({
  slot,
  isAdmin,
  brandRequests,
  onClick
}: TimelineSlotProps) {
  const matchingRequest = brandRequests?.find(req => req.stores.some(s => s.storeId === slot.storeId) && (req.mediaTypes?.includes(slot.mediaType) || (req as any).mediaType === slot.mediaType) && req.weekNumber === slot.weekNumber && req.status !== 'rejected');
  let customStyle = '';
  let label1 = '';
  let label2 = '';
  if (matchingRequest && (slot.status === 'available' || slot.status === 'booked')) {
    if ((matchingRequest.status === 'draft' || matchingRequest.status === 'pending') && slot.status === 'available') {
      customStyle = 'bg-requested-bg border-requested/50 text-requested hover:bg-requested/20 cursor-pointer';
      label1 = matchingRequest.status === 'draft' ? 'Pending' : 'Requested';
      label2 = matchingRequest.brandName;
    } else if (matchingRequest.status === 'brand-accepted' && slot.status === 'available') {
      customStyle = 'bg-amber-50 border-amber-400/50 text-amber-700 hover:bg-amber-100 cursor-pointer';
      label1 = 'Confirmed';
      label2 = 'Awaiting WW';
    } else if ((matchingRequest.status === 'accepted' || matchingRequest.status === 'accepted-with-conditions') && (slot.status === 'available' || slot.status === 'booked')) {
      customStyle = 'bg-available-bg border-available/50 text-available hover:bg-available/20 cursor-pointer';
      label1 = 'Booked';
      label2 = matchingRequest.brandName;
    }
  }
  const isClickable = slot.status === 'available' || isAdmin && (slot.status === 'blocked' || slot.status === 'booked' || slot.status === 'internal');
  const statusStyles = {
    available: 'bg-available-bg border-available/30 text-available hover:bg-available/20 cursor-pointer',
    booked: isAdmin ? 'bg-booked/20 border-booked text-text-secondary hover:bg-booked/30 cursor-pointer' : 'bg-booked/20 border-booked text-text-secondary cursor-default',
    blocked: isAdmin ? 'bg-blocked border-blocked text-white hover:bg-blocked/80 cursor-pointer' : 'bg-blocked border-blocked text-white cursor-default',
    internal: isAdmin ? 'bg-internal-bg border-internal/30 text-internal hover:bg-internal/20 cursor-pointer' : 'bg-internal-bg border-internal/30 text-internal cursor-default',
    removed: 'bg-removed-bg border-removed/30 text-text-tertiary cursor-default'
  };
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-ZA', {
      day: 'numeric',
      month: 'short'
    });
  };
  return <button onClick={isClickable ? onClick : undefined} disabled={!isClickable} className={`
        w-28 h-16 flex-shrink-0
        border rounded-sm
        flex flex-col items-center justify-center
        transition-colors duration-150
        focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1
        ${customStyle || statusStyles[slot.status]}
      `} aria-label={`Week ${slot.weekNumber}: ${label1 || slot.status}${label2 || slot.brandName && isAdmin ? ` - ${label2 || slot.brandName}` : ''}`} data-id="element-1031">
      {customStyle ? <>
          <span className="text-xs font-medium" data-id="element-1032">{label1}</span>
          <span className="text-[10px] opacity-90 truncate max-w-[100px] px-1" data-id="element-1033">
            {label2}
          </span>
        </> : slot.status === 'available' ? <>
          <span className="text-xs font-medium" data-id="element-1034">Available</span>
          {!isAdmin && <span className="text-[10px] opacity-75" data-id="element-1035">
              R{(slot.price / 1000).toFixed(0)}k
            </span>}
        </> : slot.status === 'booked' ? <>
          <span className="text-xs font-medium" data-id="element-1036">Booked</span>
          {isAdmin && <span className="text-[10px] opacity-75 truncate max-w-[100px] px-1" data-id="element-1037">
              {slot.internalCampaignName || slot.brandName || 'Woolworths'}
            </span>}
          {isAdmin && slot.internalCampaignName && <span className="text-[9px] italic opacity-60" data-id="element-1038">
              Internal Campaign
            </span>}
        </> : slot.status === 'blocked' ? <span className="text-xs font-medium" data-id="element-1039">Blocked</span> : slot.status === 'internal' ? <>
          <span className="text-xs font-medium" data-id="element-1040">Woolworths</span>
          {isAdmin && slot.internalCampaignName && <span className="text-[10px] opacity-75 truncate max-w-[100px] px-1" data-id="element-1041">
              {slot.internalCampaignName}
            </span>}
        </> : slot.status === 'removed' ? <span className="text-xs font-medium opacity-75" data-id="element-1042">Removed</span> : null}
    </button>;
}